export default __webpack_public_path__ + "static/media/hamburgerIcon.deacc2fa.svg";